const COOKIE_NAME = "smww_attribution";

export function captureAttribution() {
  const params = new URLSearchParams(window.location.search);
// Also capture attribution parameters after the URL hash
const hash = window.location.hash;

if (hash.includes("?")) {
  const hashParams = new URLSearchParams(
    hash.substring(hash.indexOf("?") + 1)
  );

  hashParams.forEach((value, key) => {
    params.set(key, value);
  });
}
  const visit = {
    landing_url: window.location.origin +
             window.location.pathname +
             window.location.search+
  window.location.hash,
    landing_path: window.location.pathname,
    referrer: document.referrer || "",
    captured_at: new Date().toISOString(),
     ga_client_id: getGAClientId(),
  ga_session_id: getGASessionId(),
    payload: {},
  };

  params.forEach((value, key) => {
    visit.payload[key] = value;

    if (key.startsWith("utm_")) {
      visit[key] = value;
    }

    if (
      ["gclid", "gbraid", "wbraid", "gad_source", "fbclid", "li_fat_id"].includes(key)
    ) {
      visit[key] = value;
    }
  });
  //Only capture marketing attribution visits
  const hasAttribution =
    Object.keys(visit).some(key => key.startsWith("utm_")) ||
    visit.gclid ||
    visit.gbraid ||
    visit.wbraid ||
    visit.fbclid ||
    visit.li_fat_id ||
    visit.gad_source;

  if (!hasAttribution) {
    return;
  }

// Derive channel
if (visit.utm_medium) {
  const medium = visit.utm_medium.toLowerCase();

  if (medium === "cpc" || medium === "ppc" || medium.startsWith("paid")) {
    visit.channel = "paid";
  } else if (medium === "email") {
    visit.channel = "email";
  } else if (medium === "social" || medium === "paidsocial") {
    visit.channel = "social";
  } else {
    visit.channel = medium;
  }
} else if (visit.gclid || visit.fbclid || visit.li_fat_id) {
  visit.channel = "paid";
} else if (visit.referrer) {
  visit.channel = "referral";
} else {
  visit.channel = "direct";
}
  // Don't create cookie if nothing useful is present
  if (Object.keys(visit.payload).length === 0) {
    return;
  }

  let attribution = getCookie(COOKIE_NAME);

  if (!attribution) {
    attribution = {
      anonymous_id: crypto.randomUUID(),
      visits: [],
    };
  }

  const lastVisit =
  attribution.visits.length > 0
    ? attribution.visits[attribution.visits.length - 1]
    : null;

if (isDuplicateVisit(lastVisit, visit)) {
    attribution.visits[attribution.visits.length - 1] = {
        ...lastVisit,
        ...visit
    };
} else {
    attribution.visits.push(visit);
}

  document.cookie =
    COOKIE_NAME +
    "=" +
    encodeURIComponent(JSON.stringify(attribution)) +
     ";domain=.preferati.net" +
    ";path=/;max-age=" +
    90 * 24 * 60 * 60 +
    ";SameSite=Lax";
}
export function getAttributionCookie() {
  const cookies = document.cookie.split("; ");

  for (const cookie of cookies) {
    const [key, value] = cookie.split("=");

    if (key === "smww_attribution") {
      console.log("Cookie value:", value);
      console.log("Decoded:", decodeURIComponent(value));

      return JSON.parse(decodeURIComponent(value));
    }
  }

  return null;
}
export function clearAttributionCookie() {
  document.cookie =
    "smww_attribution=; Path=/; Domain=.preferati.net; Max-Age=0; SameSite=Lax";
}
function getCookie(name) {
  const cookies = document.cookie.split("; ");

  for (const cookie of cookies) {
    const [key, value] = cookie.split("=");

    if (key === name) {
      return JSON.parse(decodeURIComponent(value));
    }
  }

  return null;
}
function isDuplicateVisit(lastVisit, newVisit) {
  if (!lastVisit) {
    return false;
  }

  const clickIds = [
    "gclid",
    "gbraid",
    "wbraid",
    "fbclid",
    "li_fat_id"
  ];

  // Same click ID = same visit
  for (const key of clickIds) {
    if (
      lastVisit[key] &&
      newVisit[key] &&
      lastVisit[key] === newVisit[key]
    ) {
      return true;
    }
  }

  // Same UTM visit = duplicate
  return (
    lastVisit.utm_source === newVisit.utm_source &&
    lastVisit.utm_medium === newVisit.utm_medium &&
    lastVisit.utm_campaign === newVisit.utm_campaign &&
    lastVisit.utm_content === newVisit.utm_content &&
    lastVisit.utm_term === newVisit.utm_term &&
    lastVisit.landing_path === newVisit.landing_path
  );
}
function getGAClientId() {
  const cookies = document.cookie.split(";");

  for (let cookie of cookies) {
    cookie = cookie.trim();

    if (cookie.startsWith("_ga=")) {
      const value = cookie.substring(4); // remove "_ga="

      // Example:
      // GA1.1.1365992503.1684221304
      return value.replace(/^GA\d+\.\d+\./, "");
    }
  }

  return "";
}
function getGASessionId() {
  const cookies = document.cookie.split(";");

  for (let cookie of cookies) {
    cookie = cookie.trim();

    if (cookie.startsWith("_ga_5X1RLSMBNY=")) {
      const value = cookie.substring("_ga_5X1RLSMBNY=".length);

      // GS1.1 format
      // GS1.1.<session_id>....
      let match = value.match(/^GS1\.1\.(\d+)/);

      if (match) {
        return match[1];
      }

      // If GS1.1 is not available, use GS2.1
      // GS2.1.s<session_id>$...
      match = value.match(/^GS2\.1\.s(\d+)/);

      if (match) {
        return match[1];
      }
    }
  }

  return "";
}